var _circle, _circle2, _circle3, _circle4, _circle5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup95(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 63,
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4745,
    cy: 17.2433,
    r: 1.20298,
    transform: "rotate(-90 30.4745 17.2433)",
    fill: "#212931"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.20298,
    cy: 60.9513,
    r: 1.20298,
    transform: "rotate(-90 1.20298 60.9513)",
    fill: "#212931"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5252,
    cy: 10.4259,
    r: 1.20298,
    transform: "rotate(-90 50.5252 10.4259)",
    fill: "#212931"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.81626,
    cy: 1.20327,
    r: 1.20298,
    transform: "rotate(-90 6.81626 1.20327)",
    fill: "#212931"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9256,
    cy: 30.4757,
    r: 1.20298,
    transform: "rotate(-90 50.9256 30.4757)",
    fill: "#212931"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1267 10.6269L30.6761 17.0428M51.1267 10.6269L6.61652 1.20358M51.1267 10.6269L51.1267 30.075L30.6761 17.0428M30.6761 17.0428L1.20312 60.751L6.61652 1.20358M30.6761 17.0428L6.61652 1.20358",
    stroke: "#212931",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup95);
export default __webpack_public_path__ + "static/media/Group 95.5a4ca1d87e2ef44b774365f3b7cbffb6.svg";
export { ForwardRef as ReactComponent };